import { handleActions } from "redux-actions";
import { NOTES } from "constants/action-types";
import { fetchActions, initialBaseState, updateActions, IFetchStoreState } from "./base-reducers";
import { IInternalNote } from "components/internal-notes/note-types";

export const internalNotes = handleActions<IFetchStoreState<IInternalNote[]>>(
    {
        ...fetchActions(NOTES.FETCH),
        ...updateActions(NOTES),
    } as any,
    initialBaseState,
);
